const getDefaultState = () => {
  return {
    map: {},
    api: {},
    places: [],
  }
}

const state = getDefaultState()

const getters = {
  getPlaces: (state) => state.places,
  getMap: (state) => state.map,
  getApi: (state) => state.api
}

const actions = {
  updateMap({ commit }, { map, api }) {
    commit('setMap', { map, api })
  },
  fetchPlaces({ commit, state, rootGetters }, word) {
    const center = rootGetters['map/getCenter']
    const service = new state.api.maps.places.PlacesService(state.map);
    const location = new state.api.maps.LatLng(center.lat, center.lng);

    const request = {
      location: location,
      radius: '500',
      query: word
    }

    service.textSearch(request, (results, status) => {
      if (status == state.api.maps.places.PlacesServiceStatus.OK) {
        commit('setPlaces', results.map(r => {
          return {
            name: r.name,
            address: r.formatted_address,
            location: {
              latitude: r.geometry.location.lat(),
              longitude: r.geometry.location.lng()
            },
            isGooglePlace: true,
            isEkispertPlace: false
          }
        }))
      }
    })
  },
  reset ({ commit }) {
    commit('resetState')
  },
}

const mutations = {
  setMap (state, { map, api }) {
    state.map = map
    state.api = api
  },
  setPlaces (state, results) {
    state.places = results
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
